var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtMaximum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6005 52.6523C39.5265 51.9886 40.9102 50.1603 40.9102 48.0088C40.9102 45.8573 39.5265 44.029 37.6005 43.3652L61.5869 47.363C62.3164 47.4845 62.3164 48.533 61.5869 48.6546L37.6005 52.6523Z",
    fill: "url(#paint0_linear_430_14778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 52.9192C38.7119 52.9192 40.9103 50.7208 40.9103 48.0089C40.9103 45.297 38.7119 43.0986 36 43.0986C33.2881 43.0986 31.0897 45.297 31.0897 48.0089C31.0897 50.7208 33.2881 52.9192 36 52.9192ZM36 51.2825C37.8079 51.2825 39.2735 49.8168 39.2735 48.0089C39.2735 46.201 37.8079 44.7354 36 44.7354C34.1921 44.7354 32.7265 46.201 32.7265 48.0089C32.7265 49.8168 34.1921 51.2825 36 51.2825Z",
    fill: "#F5314D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2735 48.0089C39.2735 49.8168 37.8079 51.2824 36 51.2824C34.192 51.2824 32.7264 49.8168 32.7264 48.0089C32.7264 46.201 34.192 44.7354 36 44.7354C37.8079 44.7354 39.2735 46.201 39.2735 48.0089Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2823 19.1072C32.1601 18.7357 34.0756 18.5469 36.0021 18.5471C37.9285 18.5472 39.844 18.7362 41.7218 19.108L42.9888 12.7086C40.728 12.2437 38.3912 12 36 12C33.6105 12 31.2755 12.2433 29.0162 12.7075L30.2823 19.1072Z",
    fill: "url(#paint1_linear_430_14778)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3312 19.5763C17.9873 16.6922 22.186 14.5199 26.7388 13.2568L28.4134 19.5406C26.5637 20.0335 24.7606 20.7071 23.0309 21.5551C21.3011 22.4032 19.6643 23.416 18.1418 24.5763L14.3312 19.5763Z",
    fill: "url(#paint2_linear_430_14778)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14379 32.0789C6.26815 27.877 9.13085 24.1461 12.5513 21.075L16.6547 25.7883C15.2109 27.0452 13.8885 28.4438 12.7088 29.9668C11.529 31.4898 10.5054 33.1198 9.64921 34.8319L4.14379 32.0789Z",
    fill: "url(#paint3_linear_430_14778)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.34123 44.3757C0.82161 40.7905 1.78502 37.3672 3.16046 34.18L8.8475 36.5748C8.10458 38.339 7.53303 40.177 7.14429 42.0638C6.94236 43.044 6.79096 44.0315 6.68999 45.0225L0.34123 44.3757Z",
    fill: "url(#paint4_linear_430_14778)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.8049C0.0227587 47.719 0.089501 46.6444 0.198438 45.583L6.60565 46.0171C6.53812 47.0138 6.52136 48.2352 6.55527 49.2325H0.0119989C0.00715247 49.09 0.00315278 48.9475 0 48.8049Z",
    fill: "url(#paint5_linear_430_14778)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8018 45.5851C71.9106 46.6458 71.9772 47.7197 72 48.8048C71.9968 48.9474 71.9928 49.09 71.988 49.2325H65.4447C65.4786 48.2358 65.4619 47.015 65.3945 46.0189L71.8018 45.5851Z",
    fill: "url(#paint6_linear_430_14778)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8415 34.1846C70.2163 37.3713 71.1791 40.794 71.6591 44.3785L65.3102 45.0249C65.2094 44.0344 65.0582 43.0475 64.8565 42.0679C64.4681 40.181 63.8968 38.343 63.1541 36.5787L68.8415 34.1846Z",
    fill: "url(#paint7_linear_430_14778)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4525 21.0784C62.8725 24.15 65.7347 27.8812 67.8585 32.0834L62.3526 34.8356C61.4967 33.1234 60.4733 31.4933 59.2938 29.9701C58.1142 28.447 56.7921 27.0481 55.3485 25.791L59.4525 21.0784Z",
    fill: "url(#paint8_linear_430_14778)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2661 13.2581C49.8187 14.5219 54.0171 16.6948 57.6727 19.5795L53.8615 24.5789C52.3391 23.4183 50.7025 22.4053 48.9729 21.557C47.2432 20.7087 45.4402 20.0349 43.5906 19.5417L45.2661 13.2581Z",
    fill: "url(#paint9_linear_430_14778)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_430_14778",
    x1: 65.4617,
    y1: 48.0088,
    x2: 36,
    y2: 48.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_430_14778",
    x1: 71.4234,
    y1: 56.1108,
    x2: 0.323436,
    y2: 56.1108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C68F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtMaximum);
export default __webpack_public_path__ + "static/media/Art-Maximum.83b786a1c729f3a40a7d386e52ee1a19.svg";
export { ForwardRef as ReactComponent };